var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.ready,
          expression: "ready",
        },
      ],
      staticClass: "cafe_type3",
      attrs: { id: "daumWrap" },
    },
    [
      _c(
        "header",
        {
          staticClass: "daum_head daum_head--fixed",
          attrs: { id: "daumHead" },
        },
        [
          _c("div", { staticClass: "cafe_head" }, [
            _c("h1", { staticClass: "sr_only" }, [_vm._v(_vm._s(_vm.grpname))]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "cafe_navi cafe_navi_type1",
                attrs: { id: "cafe_navi_default" },
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("close-button"),
                _vm._v(" "),
                _c("h3", { staticClass: "sr_only" }, [_vm._v("설정")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "calendar_setting" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "ico_cafe ico_alarm",
                        on: { click: _vm.onAlarmClick },
                      },
                      [_vm._v("알림")]
                    ),
                    _vm._v(" "),
                    _c("category-select"),
                    _vm._v(" "),
                    _c("today-button"),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "main",
        { staticClass: "cont_schedule", attrs: { id: "daumContent" } },
        [
          _c(
            "article",
            { class: _vm.articleClass, attrs: { id: "mArticle" } },
            [
              _c("fold-button", [_vm._v(_vm._s(_vm.monthText))]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "hammer",
                      rawName: "v-hammer:pan",
                      value: _vm.onPan,
                      expression: "onPan",
                      arg: "pan",
                    },
                  ],
                  staticClass: "calendar_wrapper",
                  style: _vm.swiperStyle,
                },
                [
                  !_vm.isFolded
                    ? _c("calendar", {
                        attrs: { year: _vm.year, month: _vm.month - 1 },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isFolded
                    ? _c("calendar", {
                        attrs: {
                          "is-center": true,
                          year: _vm.year,
                          month: _vm.month,
                        },
                        on: {
                          "calendar-length-change": _vm.onCalendarLengthChange,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isFolded
                    ? _c("calendar", {
                        attrs: { year: _vm.year, month: _vm.month + 1 },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("h3", { staticClass: "sr_only" }, [_vm._v("스케줄 목록")]),
              _vm._v(" "),
              _c(
                "div",
                { ref: "scheduleList", staticClass: "schedule_list" },
                [
                  _vm.isEmpty
                    ? _c("p", { staticClass: "desc_none" }, [
                        _vm._v("해당 월에 등록된 일정이 없습니다."),
                      ])
                    : [
                        _vm._l(_vm.currentSchedules, function (dailySchedules) {
                          return dailySchedules[1].length
                            ? _c("daily-schedule", {
                                attrs: {
                                  date: dailySchedules[0],
                                  schedules: dailySchedules[1],
                                },
                              })
                            : _vm._e()
                        }),
                        _vm._v(" "),
                        _c("img", {
                          class: _vm.flagClass,
                          attrs: {
                            src: "//t1.daumcdn.net/cafe_image/mobile/flags/ico_kor_flag.png",
                            alt: "한국국기",
                          },
                        }),
                      ],
                ],
                2
              ),
              _vm._v(" "),
              _vm.isAdmin
                ? _c("add-button", { attrs: { "calendar-id": _vm.calendarId } })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h2", { staticClass: "tit_calendar" }, [
      _c("span", { staticClass: "ico_cafe ico_calendar" }, [
        _vm._v("cafe 캘린더"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }